import { ProcedureType } from "api/type";

export const breastAugModels: string[] = [
  "https://clinic-os.com/flow-assets/model-picker/breast%20aug/breast_augmentation_model_0003_0815.png",
  "https://clinic-os.com/flow-assets/model-picker/breast%20aug/breast_augmentation_model_0001_0815.png",
  "https://clinic-os.com/flow-assets/model-picker/breast%20aug/breast_augmentation_model_0002_0815.png",
];

export const breastLiftModels: string[] = [
  "https://clinic-os.com/flow-assets/model-picker/breast%20lift/breast_lift_model_0001_0815.png",
  "https://clinic-os.com/flow-assets/model-picker/breast%20lift/breast_lift_model_0003_0815.png",
  "https://clinic-os.com/flow-assets/model-picker/breast%20lift/breast_lift_model_0002_0815.png",
];

export const breastLiftAndAugModels: string[] = [
  "https://clinic-os.com/flow-assets/model-picker/breast%20lift%20and%20aug/breast_lift_and_aug_model_0001_0815.png",
  "https://clinic-os.com/flow-assets/model-picker/breast%20lift%20and%20aug/breast_lift_and_aug_model_0002_0815.png",
  "https://clinic-os.com/flow-assets/model-picker/breast%20lift%20and%20aug/breast_lift_and_aug_model_0003_0815.png",
];

export const breastReductionModels: string[] = [
  "https://clinic-os.com/flow-assets/model-picker/breast%20reduction/breast_reduction_model_0001_0815.png",
  "https://clinic-os.com/flow-assets/model-picker/breast%20reduction/breast_reduction_model_0002_0815.png",
  "https://clinic-os.com/flow-assets/model-picker/breast%20reduction/breast_reduction_model_0003_0815.png",
];

export const tummyTuckModels: string[] = [
  "https://clinic-os.com/flow-assets/model-picker/tummy%20tuck/tummy_tuck_model_0001_0815.png",
  "https://clinic-os.com/flow-assets/model-picker/tummy%20tuck/tummy_tuck_model_0002_0815.png",
  "https://clinic-os.com/flow-assets/model-picker/tummy%20tuck/tummy_tuck_model_0003_0815.png",
];

export const bblModels: string[] = [
  "https://clinic-os.com/flow-assets/model-picker/bbl/bbl_model_0008_0815.png",
  "https://clinic-os.com/flow-assets/model-picker/bbl/bbl_model_0007_0815.png",
  "https://clinic-os.com/flow-assets/model-picker/bbl/bbl_model_0009_0815.png",
];

export const lipFillerModels: string[] = [
  // "https://clinic-os.com/flow-assets/model-picker/lip-filler/lip_filler_model_0001_1001.png",
  // "https://clinic-os.com/flow-assets/model-picker/lip-filler/lip_filler_model_0002_1001.png",
  // "https://clinic-os.com/flow-assets/model-picker/lip-filler/lip_filler_model_0003_1001.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-36.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-37.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-38.png",
];

export const adjustTextMapSpanish: Record<ProcedureType, string> = {
  BREAST_AUGMENTATION: "Ajustar el tamaño del implante",
  BREAST_LIFT_AND_AUGMENTATION: "Ajustar el tamaño del implante",
  BREAST_LIFT: "Ajustar la cantidad de levantamiento",
  BBL: "Ajustar la cantidad de BBL",
  TUMMY_TUCK: "",
  LIP_FILLER: "",
  BREAST_REDUCTION: "",
  [ProcedureType.BURN_REPAIR]: "",
  [ProcedureType.SCAR_REVISION]: "",
  [ProcedureType.HAND_SURGERY]: "",
  [ProcedureType.RECONSTRUCTIVE_SURGERY]: "",
  [ProcedureType.HAIR_TRANSPLANTATION]: "",
  [ProcedureType.BOTOX_INJECTIONS]: "",
  [ProcedureType.DERMAL_FILLERS]: "",
  [ProcedureType.LASER_TREATMENTS]: "",
  [ProcedureType.CHEMICAL_PEEL]: "",
  [ProcedureType.MICRODERMABRASION]: "",
  [ProcedureType.LASER_HAIR_REMOVAL]: "",
  [ProcedureType.THIGH_LIFT]: "",
  [ProcedureType.ARM_LIFT]: "",
  [ProcedureType.BUTTOCK_AUGMENTATION]: "",
  [ProcedureType.BODY_LIFT]: "",
  [ProcedureType.LIPOSUCTION]: "",
  [ProcedureType.CHEEK_AUGMENTATION]: "",
  [ProcedureType.CHIN_SURGERY]: "",
  [ProcedureType.FOREHEAD_LIFT]: "",
  [ProcedureType.OTOPLASTY]: "",
  [ProcedureType.RHYTIDECTOMY]: "",
  [ProcedureType.BLEPHAROPLASTY]: "",
  [ProcedureType.RHINOPLASTY]: "",
  [ProcedureType.RENUVION]: "",
  [ProcedureType.ABDOMINAL_ETCHING]: "",
  [ProcedureType.THIGH_LIPOSUCTION]: "",
  [ProcedureType.ARMS_LIPOSUCTION]: "",
  [ProcedureType.CHIN_LIPOSUCTION]: "",
  [ProcedureType.LABIAPLASTY]: "",
  [ProcedureType.VAGINAL_TIGHTENING]: "",
  [ProcedureType.VAGINAL_PRP]: "",
  [ProcedureType.HAIR_TRANSPLANT]: "",
  [ProcedureType.BIOCHETOMY]: "",
  [ProcedureType.FACE_LIFT]: "",
  [ProcedureType.CHIN_IMPLANT]: "",
};

export const adjustTextMap: Record<ProcedureType | "", string> = {
  BREAST_AUGMENTATION: "Adjust the implant size",
  BREAST_LIFT_AND_AUGMENTATION: "Adjust the implant size",
  BREAST_LIFT: "Adjust amount of lift",
  BBL: "Adjust BBL amount",
  LIP_FILLER: "Adjust lip size",
  TUMMY_TUCK: "",
  BREAST_REDUCTION: "",
  [ProcedureType.BURN_REPAIR]: "",
  [ProcedureType.SCAR_REVISION]: "",
  [ProcedureType.HAND_SURGERY]: "",
  [ProcedureType.RECONSTRUCTIVE_SURGERY]: "",
  [ProcedureType.HAIR_TRANSPLANTATION]: "",
  [ProcedureType.BOTOX_INJECTIONS]: "",
  [ProcedureType.DERMAL_FILLERS]: "",
  [ProcedureType.LASER_TREATMENTS]: "",
  [ProcedureType.CHEMICAL_PEEL]: "",
  [ProcedureType.MICRODERMABRASION]: "",
  [ProcedureType.LASER_HAIR_REMOVAL]: "",
  [ProcedureType.THIGH_LIFT]: "",
  [ProcedureType.ARM_LIFT]: "",
  [ProcedureType.BUTTOCK_AUGMENTATION]: "",
  [ProcedureType.BODY_LIFT]: "",
  [ProcedureType.LIPOSUCTION]: "",
  [ProcedureType.CHEEK_AUGMENTATION]: "",
  [ProcedureType.CHIN_SURGERY]: "",
  [ProcedureType.FOREHEAD_LIFT]: "",
  [ProcedureType.OTOPLASTY]: "",
  [ProcedureType.RHYTIDECTOMY]: "",
  [ProcedureType.BLEPHAROPLASTY]: "",
  [ProcedureType.RHINOPLASTY]: "",
  [ProcedureType.RENUVION]: "",
  [ProcedureType.ABDOMINAL_ETCHING]: "",
  [ProcedureType.THIGH_LIPOSUCTION]: "",
  [ProcedureType.ARMS_LIPOSUCTION]: "",
  [ProcedureType.CHIN_LIPOSUCTION]: "",
  [ProcedureType.LABIAPLASTY]: "",
  [ProcedureType.VAGINAL_TIGHTENING]: "",
  [ProcedureType.VAGINAL_PRP]: "",
  [ProcedureType.HAIR_TRANSPLANT]: "",
  [ProcedureType.BIOCHETOMY]: "",
  [ProcedureType.FACE_LIFT]: "",
  [ProcedureType.CHIN_IMPLANT]: "",
  "": "",
};

export const procedureTypeSpanishMap: Record<ProcedureType, string> = {
  [ProcedureType.LIP_FILLER]: "Relleno de labios",
  [ProcedureType.BREAST_AUGMENTATION]: "Aumento de senos",
  [ProcedureType.BREAST_LIFT_AND_AUGMENTATION]:
    "Levantamiento de senos y aumento",
  [ProcedureType.BREAST_LIFT]: "Levantamiento de senos",
  [ProcedureType.BBL]: "BBL",
  [ProcedureType.TUMMY_TUCK]: "Abdominoplastia",
  [ProcedureType.BREAST_REDUCTION]: "Reducción de senos",
  [ProcedureType.BURN_REPAIR]: "Reparación de quemaduras",
  [ProcedureType.SCAR_REVISION]: "Revisión de cicatrices",
  [ProcedureType.HAND_SURGERY]: "Cirugía de mano",
  [ProcedureType.RECONSTRUCTIVE_SURGERY]: "Cirugía reconstructiva",
  [ProcedureType.HAIR_TRANSPLANTATION]: "Trasplante de cabello",
  [ProcedureType.BOTOX_INJECTIONS]: "Inyecciones de Botox",
  [ProcedureType.DERMAL_FILLERS]: "Rellenos dérmicos",
  [ProcedureType.LASER_TREATMENTS]: "Tratamientos con láser",
  [ProcedureType.CHEMICAL_PEEL]: "Peeling químico",
  [ProcedureType.MICRODERMABRASION]: "Microdermoabrasión",
  [ProcedureType.LASER_HAIR_REMOVAL]: "Depilación láser",
  [ProcedureType.THIGH_LIFT]: "Levantamiento de muslos",
  [ProcedureType.ARM_LIFT]: "Levantamiento de brazos",
  [ProcedureType.BUTTOCK_AUGMENTATION]: "Aumento de glúteos",
  [ProcedureType.BODY_LIFT]: "Levantamiento de cuerpo",
  [ProcedureType.LIPOSUCTION]: "Liposucción",
  [ProcedureType.CHEEK_AUGMENTATION]: "Aumento de mejillas",
  [ProcedureType.CHIN_SURGERY]: "Cirugía de mentón",
  [ProcedureType.FOREHEAD_LIFT]: "Levantamiento de frente",
  [ProcedureType.OTOPLASTY]: "Otoplastia",
  [ProcedureType.RHYTIDECTOMY]: "Ritidectomía",
  [ProcedureType.BLEPHAROPLASTY]: "Blefaroplastia",
  [ProcedureType.RHINOPLASTY]: "Rinoplastia",
  [ProcedureType.RENUVION]: "Renuvion",
  [ProcedureType.ABDOMINAL_ETCHING]: "Grabado abdominal",
  [ProcedureType.THIGH_LIPOSUCTION]: "Liposucción de muslos",
  [ProcedureType.ARMS_LIPOSUCTION]: "Liposucción de brazos",
  [ProcedureType.CHIN_LIPOSUCTION]: "Liposucción de mentón",
  [ProcedureType.LABIAPLASTY]: "Labioplastia",
  [ProcedureType.VAGINAL_TIGHTENING]: "Estrechamiento vaginal",
  [ProcedureType.VAGINAL_PRP]: "PRP vaginal",
  [ProcedureType.HAIR_TRANSPLANT]: "Trasplante de cabello",
  [ProcedureType.BIOCHETOMY]: "Biochetomía",
  [ProcedureType.FACE_LIFT]: "Estiramiento facial",
  [ProcedureType.CHIN_IMPLANT]: "Implante de mentón",
};

export const bodyProcedureTypes: ProcedureType[] = [
  ProcedureType.BBL,
  ProcedureType.LIPOSUCTION,
  ProcedureType.TUMMY_TUCK,
  ProcedureType.RENUVION,
  ProcedureType.ABDOMINAL_ETCHING,
  ProcedureType.THIGH_LIPOSUCTION,
  ProcedureType.ARMS_LIPOSUCTION,
  ProcedureType.CHIN_LIPOSUCTION,
];

export const faceProcedureTypes: ProcedureType[] = [
  ProcedureType.BLEPHAROPLASTY,
  ProcedureType.BIOCHETOMY,
  ProcedureType.FACE_LIFT,
  ProcedureType.RHINOPLASTY,
  ProcedureType.CHIN_IMPLANT,
];

export const breastProcedureTypes: ProcedureType[] = [
  ProcedureType.BREAST_AUGMENTATION,
  ProcedureType.BREAST_LIFT,
  ProcedureType.BREAST_REDUCTION,
];

export const vaginalProcedureTypes: ProcedureType[] = [
  ProcedureType.LABIAPLASTY,
  ProcedureType.VAGINAL_TIGHTENING,
  ProcedureType.VAGINAL_PRP,
];

export const hairProcedureTypes: ProcedureType[] = [
  ProcedureType.HAIR_TRANSPLANT,
];
